import {GET, POST} from '../index'

// 获取资讯列表
export const newsList = (data) => {
  return GET('/news/list', data)
}

// 更改资讯状态接口
export const changeNewsStatus = (data) => {
  return POST('/news/change/status', data)
}

// 添加资讯
export const addNews = (data) => {
  return POST('/news/add', data)
}

// 资讯详情
export const newsInfo = (data) => {
  return GET('/news/info', data)
}

// 编辑资讯
export const editNews = (data) => {
  return POST('/news/edit', data)
}

// 删除资讯
export const delNews = (data) => {
  return POST('/news/del', data)
}
// 更改排序
export const changeSort = (data) => {
  return POST('/news/change/sort', data)
}



// WEBPACK FOOTER //
// ./src/api/news/index.js